import "./accordion";
import {resizableSwiper, staticSwipers} from "./main-slider";

const mediaQuerySlider = window.matchMedia("(max-width: 768px)");
const mediaQueryOfficesSlider = window.matchMedia("(max-width: 650px)");

let counterPress = 2;
const pressShowBtn = document.querySelector('.js-press-show');

if (pressShowBtn) {
    pressShowBtn.addEventListener('click', (event) => {
        event.preventDefault();
        let element = event.target;

        if (element.closest('.js-press-show')) {
            pressShowBtn.setAttribute('disabled', 'disabled');
            $.ajax({
                url: `${location.pathname}?page=${counterPress}`,
                method: 'get',
            }).done(res => {
                if (res.items_html) {
                    $('.press__wrapper').append(res.items_html);
                }
                counterPress++;
                if (!res.has_next) {
                    pressShowBtn.classList.add('press__button-more--none')
                }
            }).always(() => {
                pressShowBtn.removeAttribute('disabled');
            });
        }
    });
}


document.addEventListener("DOMContentLoaded", () => {
    const body = document.body;
    const WINDOW_HEIGHT = window.innerHeight;
    const SCROLL_HEIGHT = document.documentElement.scrollTop;
    const windowInnerWidth = document.documentElement.clientWidth;
    const shortFormModal = document.querySelector(".js-short-form-modal");
    const modalVideo = document.querySelector(".js-modal-video");
    const videoPlayer = document.querySelector(".modal__video");
    const btnUp = document.querySelector(".js-btn-up");
    const btnModalVideo = document.querySelector(".js-btn-modal-video");
    const btnOpenModalShort = document.querySelectorAll(".js-btn-modal-short");
    const btnCloseModalShort = document.querySelectorAll(".js-close-modal-short");
    const buttonBurger = document.querySelector(".button-burger");
    const header = document.querySelector(".header");
    const headerNav = document.querySelector(".header__nav");
    const animateBlocks = document.querySelectorAll(".animate-block");
    const selectItems = document.querySelectorAll(".header__sublist-item");
    const headerBackButton = document.querySelector(".header__back-btn");
    const menuList = document.querySelector('.header__list');
    const selectMenu = document.querySelector('.header__sublist');
    const selectSubMenu = document.querySelector('.header__sub-sublist');
    const spanServices = document.querySelector('.header__item-services');
    const subListLinks = document.querySelectorAll('.sub-sublist-item__link')
    const anchors = document.querySelectorAll(".js-anchors");
    const gridListAll = document.querySelectorAll(".main-grid");
    const mediaMobile = window.matchMedia("(max-width: 768px)").matches;

    function researchGrid(array) {
        array.forEach(item => {
            if (item) {
                const gridListItems = item?.querySelectorAll(".main-grid__item");
                if (gridListItems?.length === 4 || gridListItems?.length === 7 || gridListItems?.length === 10 || gridListItems?.length < 3) {
                    item.classList.add('main-grid--two');
                    item.classList.remove('main-grid--three');
                }

                if (gridListItems.length % 3 === 0) {
                    item.classList.add('main-grid--three');
                    item.classList.remove('main-grid--two');
                }

                if (gridListItems.length % 2 != 0) {
                    gridListItems[gridListItems.length - 1].classList.add('main-grid__item--last-element')
                }
            }
        });
    }

    researchGrid(gridListAll);

    // Параметры для свайпера, для стр 2 уровня(seo, smm и тд)
    const typeOneSliderParams = {
        pagination: {
            el: '.main-slider--one-resizible-slide .swiper-pagination',
            clickable: true,
        },

        slidesPerView: 1,
        spaceBetween: 15,
    };

    // Инициализация адаптивных(resize) слайдеров
    resizableSwiper('(max-width: 767px)', '.main-slider--one-resizible-slide', typeOneSliderParams);

    // Инициализация статических слайдеров
    staticSwipers();

    if (anchors) {
        anchors.forEach((item) => {
            item.addEventListener("click", (e) => {
                e.preventDefault();
                const link = e.currentTarget.getAttribute("href").slice(1);

                e.currentTarget.classList.remove("open");

                if (document.querySelector('.header__nav--active')) {
                    buttonBurger.classList.toggle('button-burger--active');
                    body.classList.toggle('stop-scroll');
                    headerNav.classList.toggle('header__nav--active')
                }

                window.scrollTo({
                    top: document.querySelector(`#${link}`).offsetTop - 50,
                    behavior: "smooth",
                });
            });
        });
    }

    body.addEventListener('click', (e) => {
        const element = e.target;
        // Short modal open ***
        if (element.classList.contains('js-btn-modal-short')) {
            shortFormModal.classList.add("feedback--visibl-modal");
            setTimeout(() => {
                shortFormModal.classList.add("feedback--open-modal");
            }, 15);
            body.classList.add("stop-scroll");
            const allShortClickFrom = document.querySelectorAll("#field_short_click_from");
            allShortClickFrom.forEach(item => {
                item.value = element.value;
            })
            document.getElementById("field_click_from").value = element.value;
            if (window.ANALYTICS_ENABLED == true) {
                (dataLayer = window.dataLayer || []).push({
                    eCategory: "Button",
                    eAction: "click",
                    eLabel: "Start project",
                    event: "GTMForms",
                });
            }
        }
        // ***

        // Short modal close ***
        if (element.classList.contains('js-close-modal-short') || element.classList.contains('js-short-form-modal')) {
            shortFormModal.classList.remove("feedback--open-modal");
            setTimeout(() => {
                shortFormModal.classList.remove("feedback--visibl-modal");
            }, 300);
            if (!buttonBurger.classList.contains('button-burger--active')) {
                body.classList.remove("stop-scroll");
            }
        }
        // ***

        // Video modal open ***
        if (element.classList.contains('js-btn-modal-video')) {
            modalVideo.classList.add("visible");
            setTimeout(() => {
                modalVideo.classList.add("active");
            }, 200);
            videoPlayer.play();
            body.classList.add("stop-scroll");
        }
        // ***

        // Button to top ***
        if (element.classList.contains('js-btn-up')) {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }
        // ***

        // Burger-menu ***
        if (element.classList.contains('button-burger')) {
            if (buttonBurger.classList.contains('button-burger--active')) {
                body.classList.remove('stop-scroll');
            } else {
                body.classList.add('stop-scroll');
            }
            buttonBurger.classList.toggle('button-burger--active');
            headerNav.classList.toggle('header__nav--active')
        }
        // ***

        // Custom scroll anchor ***
        if (element.classList.contains('header__link')) {
            e.preventDefault();
            if (element.getAttribute("href")) {
                const link = element.getAttribute("href").slice(1);
                buttonBurger.classList.remove('button-burger--active');
                body.classList.remove('stop-scroll');
                headerNav.classList.remove('header__nav--active')

                window.scrollTo({
                    top: document.querySelector(`#${link}`).offsetTop - 50,
                    behavior: "smooth",
                });
            }
        }
        // ***

        // header menu mobile ***
        if (element.classList.contains('header__item--select') && document.body.clientWidth <= 1023) {
            headerBackButton.classList.add('header__back-btn--active');
            menuList.classList.add('header__list--active');
            selectMenu.classList.add('header__sublist--active');
        }

        if (element.classList.contains('header__back-btn')) {
            headerBackButton.classList.remove('header__back-btn--active');
            menuList.classList.remove('header__list--active');
            selectMenu.classList.remove('header__sublist--active');
        }
        // ***
    });

    // selected active page
    subListLinks.forEach(el => {
        if (el.getAttribute('href') === window.location.pathname) {
            el.classList.add('sub-sublist-item__link--active');
        }
    })

    let clientWidth = document.body.clientWidth;
    if (clientWidth <= 1023) {
        selectItems.forEach(el => {
            el.addEventListener('click', (e) => {
                const elem = e.target;
                if (elem.classList.contains('sublist-item')) {
                    elem.classList.toggle('sublist-item--active');
                }
            });
        });
    }

    document.addEventListener("keydown", (e) => {
        if (e.keyCode == 27) {
            shortFormModal.classList.remove("feedback--open-modal");

            setTimeout(() => {
                shortFormModal.classList.remove("feedback--visibl-modal");
            }, 200);

            body.classList.remove("stop-scroll");

            if (modalVideo) {
                videoPlayer.muted = true;
                videoPlayer.pause();
                videoPlayer.currentTime = 0;
            }
        }
    });

    // animate block for firs loading
    for (let i = 0; i < animateBlocks.length; i++) {
        const elementTop = animateBlocks[i].getBoundingClientRect().top;
        const elementVisible = 70;

        if (elementTop < WINDOW_HEIGHT - elementVisible) {
            animateBlocks[i].classList.add("animate-block--active");
        } else {
            animateBlocks[i].classList.remove("animate-block--active");
        }
    }

    // header background for firs loading
    if (SCROLL_HEIGHT > 50) {
        header.classList.add('header--active');
    } else {
        header.classList.remove('header--active');
    }

    // button-up visible for firs loading
    if (SCROLL_HEIGHT > WINDOW_HEIGHT) {
        document.querySelector(".js-btn-up") && document.querySelector(".js-btn-up").classList.add("button-up--visible");
    } else {
        document.querySelector(".js-btn-up") && document.querySelector(".js-btn-up").classList.remove("button-up--visible");
    }

    document.addEventListener("scroll", (e) => {
        let scrollHeight = document.documentElement.scrollTop;
        let windowHeight = window.innerHeight;

        // header background
        if (scrollHeight > 50) {
            header.classList.add('header--active');
        } else {
            header.classList.remove('header--active');
        }

        // button-up visible
        if (scrollHeight > windowHeight) {
            document.querySelector(".js-btn-up") && document.querySelector(".js-btn-up").classList.add("button-up--visible");
        } else {
            document.querySelector(".js-btn-up") && document.querySelector(".js-btn-up").classList.remove("button-up--visible");
        }

        // animate block
        for (let i = 0; i < animateBlocks.length; i++) {
            const elementTop = animateBlocks[i].getBoundingClientRect().top;
            const elementVisible = 70;

            if (elementTop < windowHeight - elementVisible) {
                animateBlocks[i].classList.add("animate-block--active");
            } else {
                animateBlocks[i].classList.remove("animate-block--active");
            }
        }
    });

    const $dropBtn = document.querySelectorAll(".js-drop-btn");

    if ($dropBtn) {
        $dropBtn.forEach((item) => {
            item.addEventListener("click", (e) => {
                e.currentTarget.classList.toggle("active");
            });
        });
    }

    const $btnCloseModal = document.querySelectorAll(".js-close-modal");

    if ($btnCloseModal) {
        $btnCloseModal.forEach((item) => {
            item.addEventListener("click", (e) => {
                e.currentTarget.closest(".modal").classList.remove("active");
                document.querySelector("body").classList.remove("stop-scroll");

                if (document.querySelector(".js-modal-video")) {
                    document.querySelector(".modal__video").muted = true;
                    document.querySelector(".modal__video").pause();
                    document.querySelector(".modal__video").currentTime = 0;
                }
            });
        });
    }

    // Open big modal
    const $btnModal = document.querySelectorAll(".js-btn-modal");

    if ($btnModal) {
        $btnModal.forEach((item) => {
            item.addEventListener("click", (e) => {
                document.querySelector(".js-modal").classList.add("active");
                document.querySelector("body").classList.add("stop-scroll");
                document.getElementById("field_click_from").value = item.value;
                if (window.ANALYTICS_ENABLED == true) {
                    (dataLayer = window.dataLayer || []).push({
                        eCategory: "Button",
                        eAction: "click",
                        eLabel: "Start project",
                        event: "GTMForms",
                    });
                }
            });
        });
    }

    const $modal = document.querySelectorAll(".modal");

    document.addEventListener("keydown", function (e) {
        if (e.keyCode == 27) {
            $modal.forEach((item) => {
                item.classList.remove("active");
                document.querySelector("body").classList.remove("stop-scroll");

                if (document.querySelector(".js-modal-video")) {
                    document.querySelector(".modal__video").muted = true;
                    document.querySelector(".modal__video").pause();
                    document.querySelector(".modal__video").currentTime = 0;
                }
            });
        }
    });

    $(".modal").mouseup(function (e) {
        // событие клика по веб-документу
        var div = $(".modal__inner"); // тут указываем ID элемента
        if (
            !div.is(e.target) && // если клик был не по нашему блоку
            div.has(e.target).length === 0
        ) {
            // и не по его дочерним элементам
            $modal.forEach((item) => {
                item.classList.remove("active");
                document.querySelector("body").classList.remove("stop-scroll");
            });
        }
    });

    var vid = document.querySelector(".common__video");

    if (vid) {
        var canvas = document.querySelector(".main__banner-fake");
        var ctx = canvas.getContext("2d");

        var ratio = window.devicePixelRatio || 1;
        var vidWidth;
        var vidHeight;

        vid.addEventListener("loadedmetadata", function (e) {
            vid.style.transform = `scale(${ratio})`;

            vidWidth = vid.videoWidth;
            vidHeight = vid.videoHeight;

            canvas.width = vid.offsetWidth * ratio;
            canvas.height = vid.offsetHeight * ratio;

            canvas.style.width = vid.offsetWidth + "px";
            canvas.style.height = vid.offsetHeight + "px";

            drawingLoop();

            //resize scale for comparison
            vid.style.transform = `scale(.7)`;
        });

        vid.addEventListener("loadeddata", function (e) {
            vid.play();
        });

        function drawingLoop() {
            window.requestAnimationFrame(drawingLoop);

            ctx.drawImage(
                vid,
                0,
                0,
                vidWidth,
                vidHeight, // source rectangle
                0,
                0,
                canvas.width,
                canvas.height,
                canvas.background,
            ); // destination rectangle);
        }

        window.onresize = function (event) {
            vid.style.transform = `scale(.7)`;

            vidWidth = vid.videoWidth;
            vidHeight = vid.videoHeight;

            canvas.width = vid.offsetWidth * ratio;
            canvas.height = vid.offsetHeight * ratio;

            canvas.style.width = vid.offsetWidth + "px";
            canvas.style.height = vid.offsetHeight + "px";

            ctx.drawImage(
                vid,
                0,
                0,
                vidWidth,
                vidHeight,
                0,
                0,
                canvas.width,
                canvas.height
            );

            vid.style.transform = `scale(.7)`;
        };

        vid.src = vid.dataset.src;
        vid.play();

        (function () {
            var fixAutoPlay = function (e) {
                document.removeEventListener("touchstart", fixAutoPlay);
                document.removeEventListener("touchend", fixAutoPlay);
                document.removeEventListener("scroll", fixAutoPlay);
            };
            document.addEventListener("touchstart", fixAutoPlay);
            document.addEventListener("touchend", fixAutoPlay);
            document.addEventListener("scroll", fixAutoPlay);
        })();
    }

    const validate = (element) => {
        const $formValidate = element.closest(".js-form");

        const $formInputReq = $formValidate.querySelectorAll(
            "input[required], textarea[required]"
        );

        $formInputReq.forEach((item) => {
            if (item.getAttribute("type") !== "checkbox" && item.value == "") {
                item.closest(".js-form-item").classList.add("error-item");
            }

            if (item.getAttribute("type") !== "checkbox" && item.value !== "") {
                item.closest(".js-form-item").classList.remove("error-item");
            }

            if (item.getAttribute("type") == "checkbox" && !item.checked) {
                item.closest(".js-form-item").classList.add("error-item");
            }

            if (item.getAttribute("type") == "checkbox" && item.checked) {
                item.closest(".js-form-item").classList.remove("error-item");
            }
        });

        if ($formValidate.querySelector("#id_other_field_value")) {
            if (
                $formValidate
                    .querySelector("#id_other_field_value")
                    .getAttribute("required") &&
                $formValidate.querySelector("#id_other_field_value").value == ""
            ) {
                return;
            } else {
                const filterArr = [
                    ...$formValidate
                        .querySelector(".js-form-goals")
                        .querySelectorAll(".form__check-hidden"),
                ].filter((item) => item.checked);
                filterArr.length
                    ? $formValidate
                        .querySelector(".js-form-goals")
                        .classList.remove("error-item")
                    : $formValidate
                        .querySelector(".js-form-goals")
                        .classList.add("error-item");
            }
        }
    };

    function checkConfirm(form) {
        let check = false;
        form[0].querySelectorAll(`.js-form-item textarea`).forEach((item) => {
            if (!item.value) check = true;
        });
        form[0].querySelectorAll(`.js-form-item input`).forEach((item) => {
            if (!item.value) check = true;
        });
        form[0].querySelectorAll(`.js-form-item input[type="checkbox"`).forEach((item) => {
            if (!item.checked) check = true;
        });
        return check;
    }

    const btnSubmit = document.querySelectorAll('button[type="submit"');
    btnSubmit.forEach((item) => {
        item.disabled = true;
    })

    $(".js-form-item input").on("blur", (e) => {
        validate(e.currentTarget);
        const thisForm = $(e.currentTarget).closest("form").toggleClass(".form");
        if (!checkConfirm(thisForm)) {
            thisForm[0].querySelector('button[type="submit"').disabled = false;
        } else {
            thisForm[0].querySelector('button[type="submit"').disabled = true;
        }
    });

    $(".js-form-item input, textarea").on("input", (e) => {
        validate(e.currentTarget);
        const thisForm = $(e.currentTarget).closest("form").toggleClass(".form");
        if (!checkConfirm(thisForm)) {
            thisForm[0].querySelector('button[type="submit"').disabled = false;
        } else {
            thisForm[0].querySelector('button[type="submit"').disabled = true;
        }
    });

    function loadFilteredCases(product, limit) {
        const container = $('#case-study__container');
        $.ajax({
            type: 'GET',
            url: `${location.pathname}`,
            data: {product_name: product, limit: limit},
            success: function (data) {
                container.html(data.html);
                initShowMoreHandler();
            },
            error: function () {
            }
        })
    }

    const casesContainers = document.querySelectorAll('.cases__container');
    const btnShowMore = document.querySelector('.js-show-more');
    const btnTabs = document.querySelectorAll('.tabs__btn');
    const MOBILE_LIMIT = 3;
    const DESKTOP_LIMIT = 6;

    function initShowMoreHandler() {
        $("#show-more__btn").on("click", function (e) {
            e.preventDefault()
            var selectedProduct = $(".tabs__btn.active").attr("data-id").toUpperCase();
            if (btnTabs.length && selectedProduct === undefined) {
                selectedProduct = btnTabs[0].getAttribute("data-id").toUpperCase();
            }
            if (!selectedProduct) {
                selectedProduct = e.target.getAttribute('data-product-id')
            }

            if (selectedProduct) {
                if (!window.productLimits) {
                    window.productLimits = {}
                }

                if (!window.productLimits[selectedProduct]) {
                    if (mediaMobile) {
                        window.productLimits[selectedProduct] = MOBILE_LIMIT;
                    } else {
                        window.productLimits[selectedProduct] = DESKTOP_LIMIT;
                    }
                }

                if (mediaMobile) {
                    window.productLimits[selectedProduct] += MOBILE_LIMIT;
                } else {
                    window.productLimits[selectedProduct] += DESKTOP_LIMIT;
                }

                loadFilteredCases(selectedProduct, window.productLimits[selectedProduct]);
            } else {
                console.error("Product not selected")
            }
        })
    }

    initShowMoreHandler();

    casesContainers[0]?.classList.add('active');
    btnTabs[0]?.classList.add('active');

    if (btnTabs.length) {
        loadFilteredCases(btnTabs[0]?.getAttribute("data-id").toUpperCase(), window.productLimits[btnTabs[0]?.getAttribute("data-id").toUpperCase()]);
    }

    $('.tabs__btn').on("click", function (event) {
        event.stopImmediatePropagation();
        $('.tabs__btn').removeClass("active")
        $(this).addClass("active")
        var selectedProduct = $(this).attr("data-id").toUpperCase();

        casesContainers.forEach(item => {
            item.classList.remove('active');
            item.classList.remove('active--mobile');
            if (selectedProduct.toUpperCase() === item.getAttribute("data").toUpperCase()) {
                item.classList.add('active');

                if (item.querySelectorAll('.case-study-card').length < 3) {
                    btnShowMore?.classList.add('active');
                } else {
                    btnShowMore?.classList.remove('active');
                }
            }
        })
        loadFilteredCases(selectedProduct, window.productLimits[selectedProduct]);
    });

    if (btnShowMore) {
        btnShowMore.addEventListener("click", () => {
            btnShowMore?.classList.add("active");
            casesContainers.forEach(item => {
                if (item.classList.contains('active')) {
                    item.classList.add('active--mobile');
                }
            })
        });
    }
});